import { render, staticRenderFns } from "./cModalExamenes.vue?vue&type=template&id=4887f15f&lang=es"
import script from "./cModalExamenes.vue?vue&type=script&lang=js"
export * from "./cModalExamenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports